// extracted by mini-css-extract-plugin
module.exports = {"control":"checkbox-module--control--ji3g8","indicator":"checkbox-module--indicator--3soVT","label":"checkbox-module--label--132AM"};